import { roundNumber } from './utils';

export function renderProgress(progress) {
  let jobProgress = 0;
  if (progress) {
    jobProgress = progress * 100 > 100 ? 100 : progress * 100;
    try {
      if (jobProgress && jobProgress.toString().length > 2) jobProgress = roundNumber(jobProgress);
    } catch {
      // Ignore rounding errors
    }
  }

  return jobProgress;
}

/**
 * Check if a job has been finished (delivered or evaluated)
 * @param {Object} job - The job object to check
 * @returns {boolean} True if the job status is 'delivered' or 'evaluated'
 */
export function isJobFinished(job) {
  if (!job) {
    return false;
  }
  return job.status === 'delivered' || job.status === 'evaluated';
}

/**
 * Get frozen questions from job's frozen assessment data, with fallback to fresh questions
 * @param {Object} selectedJob - The job object that may contain freezed_assessment_data
 * @param {Array} questions - Fresh questions array to use as fallback
 * @returns {Array} Frozen questions if available, otherwise fresh questions
 */
export function getFrozenQuestions(selectedJob, questions) {
  if (selectedJob?.freezed_assessment_data) {
    try {
      const freezedData = JSON.parse(selectedJob.freezed_assessment_data);
      if (freezedData?.questions) {
        return freezedData.questions;
      }
    } catch (error) {
      console.warn('Failed to parse frozen assessment data:', error);
    }
  }
  return questions;
}
